import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSessionStore } from '../hooks';
import type { SessionStore } from './sessionService';
import { redirectToLogin } from './authUtils';

const ProtectedRoute: React.FC = () => {
  const isAuthenticated = useSessionStore((store: unknown) => (store as SessionStore).isAuthenticated);
  if (isAuthenticated === null) return null;
  if (!isAuthenticated) { redirectToLogin(); return null; }
  return <Outlet />;
};

export default ProtectedRoute;